import React from "react";
import { useSelector } from "@/types/store";
import { getArtifactsUnstructuredTable, getDatasetsStructuredTable, getDatasetViewType } from "@/containers/Sense/reducer";
import StructuredTable from "@/components/Tiles/Sense/TableView/StructuredTable";
import UnstructuredTable from "@/components/Tiles/Sense/TableView/UnstructuredTable";
const extractStructuredDataFromDatasets = (datasets) => {
    return datasets.map((dataset) => {
        const arePassedTests = !(dataset?.dataset_status === "ERROR") && (dataset?.status_name === "DONE" || Boolean(dataset?.outcome));
        const isWideDatasetWarning = dataset?.wideDatasetWarning;
        const isError = dataset?.dataset_status === "ERROR";
        const isReady = dataset?.number_of_rows !== -1;
        const isAiReady = isReady && dataset?.aiReadinessStatus !== "NO_SIGNAL";
        const isLoading = isWideDatasetWarning || (!isError && !isAiReady);
        return {
            isPinned: dataset.isPinned,
            name: dataset.name,
            id: dataset.id,
            outcome: dataset.outcome || "",
            quality: arePassedTests,
            readiness: Math.round((dataset.readiness + Number.EPSILON) * 10) / 10,
            usefulVariables: dataset.usefulVariables,
            problematicPredictors: dataset.problematicPredictors,
            insights: dataset?.interaction_scores?.length ?? 0,
            rows: dataset?.number_of_rows !== undefined && dataset?.number_of_rows !== -1 ? dataset?.number_of_rows : 0,
            columns: dataset?.fields && Object.keys(dataset.fields).length > 0
                ? isWideDatasetWarning
                    ? dataset.labels?.length
                    : Object.keys(dataset.fields).length
                : 0,
            source: dataset?.source || "Unknown",
            createdDate: dataset.created,
            owner: dataset?.created_by?.fullname || "-",
            isLoading
        };
    });
};
const TableView = () => {
    const datasetViewType = useSelector(getDatasetViewType);
    const artifacts = useSelector((state) => getArtifactsUnstructuredTable(state));
    const datasets = useSelector((state) => getDatasetsStructuredTable(state));
    if (datasetViewType === "STRUCTURED") {
        return React.createElement(StructuredTable, { dataProp: extractStructuredDataFromDatasets(datasets) });
    }
    return React.createElement(UnstructuredTable, { dataProp: artifacts });
};
export default TableView;
